<template>
  <div class="certification-apply">
    <!-- <div class="user-hint" v-if="!$store.state.companyInfo">
      <img
        class="business-license"
        src="../../assets/icon/business-license.png"
        alt=""
      />
      <div class="hint-text">
        <h3>温馨提示：</h3>
        <span>
          请提前准备好申请材料，《营业执照》副本为最新年检的扫描件或照片；《企业认证申请公函》需已盖企业公章后存档（注：合同章/财务章无效）。完成身份信息填写并审核通过后，即可创建应用啦～
        </span>
      </div>
      <div class="download-doc">
        <img src="../../assets/icon/download-icon.png" alt=""/>
        <a target="_blank" :href="agreement_form_download" download="哔哩哔哩开放平台入驻承诺函（企业）.docx">下载文档</a>
      </div>
    </div> -->
    <status-bar
      @close="topStatus = null"
      v-if="topStatus"
      :text="topStatus.text"
      :state="topStatus.type"
      class="status-bar"
    ></status-bar>
    <h2>认证申请</h2>
    <bcc-form ref="form" :model="form" :rules="rules" @submit.native.prevent>
      <bcc-form-item label="类型" required>
        <bcc-radio-group :value="1" :disabled="true">
          <bcc-radio :label="1">企业开发者</bcc-radio>
          <!-- <bcc-radio :label="2">个人开发者</bcc-radio> -->
        </bcc-radio-group>
      </bcc-form-item>
      <bcc-form-item
        label="公司名称"
        prop="co_name"
        :required="requiredKey.includes('co_name')"
      >
        <bcc-input
          v-model="form.co_name"
          placeholder="请填写您的公司名称"
          showWordLimit
          maxlength="80"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="公司网址"
        prop="net_addr"
        :required="requiredKey.includes('net_addr')"
      >
        <bcc-input
          v-model="form.net_addr"
          placeholder="请填写您的公司网址"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="企业代码"
        :required="requiredKey.includes('uscc')"
        prop="uscc"
      >
        <span class="tip"> 统一社会信用代码 / 工商执照注册号 </span>
        <bcc-input
          v-model="form.uscc"
          placeholder="请填写您的企业代码"
          style="margin-top: 16px"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item label="公司地址" required prop="company_addr">
        <bcc-input
          v-model="form.company_addr"
          placeholder="请填写您的公司地址"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="公司简介"
        :required="requiredKey.includes('description')"
        prop="description"
      >
        <bcc-input
          v-model="form.description"
          type="textarea"
          placeholder="请介绍自己的品牌、产品、服务或其他有助于外界了解贵公司的信息描述"
          maxlength="250"
          showWordLimit
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="联系人"
        :required="requiredKey.includes('contact')"
        prop="contact"
      >
        <bcc-input
          v-model="form.contact"
          placeholder="请填写联系人姓名"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="身份证号码"
        :required="requiredKey.includes('identity_cards_number')"
        prop="identity_cards_number"
      >
        <bcc-input
          v-model="form.identity_cards_number"
          placeholder="请填写正确的身份证号码"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="联系邮箱"
        :required="requiredKey.includes('email')"
        prop="email"
      >
        <bcc-input
          v-model="form.email"
          placeholder="请填写联系邮箱，如abc@bilibili.com"
          :disabled="formLock"
        ></bcc-input>
      </bcc-form-item>
      <bcc-form-item
        label="联系手机"
        :required="requiredKey.includes('tel')"
        prop="tel"
      >
        <bcc-input
          style="width: 630px; vertical-align: middle"
          v-model="form.tel"
          placeholder="请填写联系手机"
          :disabled="formLock || showVerifyCode"
        ></bcc-input>
        <bcc-verification
          is-async
          ref="bcc-verification"
          @click="sendVerification"
          position="right"
          :disabled="disableVerification"
          style="margin-left: 15px; vertical-align: middle"
        ></bcc-verification>
      </bcc-form-item>
      <bcc-form-item
        v-if="showVerifyCode"
        label="验证码"
        :required="requiredKey.includes('captcha')"
        prop="captcha"
      >
        <bcc-input
          style="width: 200px; vertical-align: middle"
          v-model="form.captcha"
          placeholder="请填写验证码"
        ></bcc-input>
        <a
          @click.prevent="resetPhone"
          style="vertical-align: middle; font-size: 12px; margin-left: 10px"
          >重新填写手机号?</a
        >
      </bcc-form-item>
      <bcc-form-item
        label="营业执照"
        :required="requiredKey.includes('license_url')"
        prop="license_url"
      >
        <ac-file-upload
          type="image"
          accept=".jpg,.jpeg,.png"
          :uploader="licenseUploader"
          :source="form.license_url"
          :show-error="errors.includes('license_url')"
          :disabled="formLock"
        ></ac-file-upload>
        <div class="tip" style="margin-top: 15px">
          请上传《营业执照》副本扫描件或照片，支持JPG、PNG等格式。建议上传高清图片，文件不超过5MB
        </div>
      </bcc-form-item>
      <bcc-form-item
        label="申请公函"
        :required="requiredKey.includes('application_url')"
        prop="application_url"
      >
        <ac-file-upload
          type="image"
          accept=".jpg,.jpeg,.png"
          :uploader="applicationUploader"
          :source="form.application_url"
          :show-error="errors.includes('application_url')"
          :disabled="formLock"
        ></ac-file-upload>
        <div class="tip" style="margin-top: 15px">
          请拖放或点击上传《企业认证申请公函》<a
            target="_blank"
            :href="agreement_form_download"
            download="哔哩哔哩开放平台入驻承诺函（企业）.docx"
            >点击下载</a
          >，支持JPG、PNG等格式，单个文件不超过5MB
        </div>
      </bcc-form-item>
      <bcc-form-item
        label="尽调问卷"
        :required="requiredKey.includes('safety_questionnaire')"
        prop="safety_questionnaire"
      >
        <UploadBtn
          :btnTxt="form.sq_file_name ? '替换附件' : '上传附件'"
          accept=".pdf"
          :uploader="questionnaireUpload"
        />
        <span class="ques-txt ellipsis-1">{{ form.sq_file_name || "" }}</span>
        <div class="tip" style="margin-top: 15px">
          请点击上传《第三方数据安全尽职调查问卷》<a
            style="color: #23ade5; cursor: pointer"
            :href="questionnaire_download"
            download="哔哩哔哩开放平台第三方数据安全尽职调查问卷.zip"
            >点击下载</a
          >，支持PDF格式，单个问题文件不超过5MB
        </div>
      </bcc-form-item>
      <!-- <bcc-form-item style="margin-top: 80px">
        <bcc-checkbox v-model="agreeArcOpenProtocol"
          >我已阅读并同意<a>《哔哩哔哩开发平台开发者协议》</a></bcc-checkbox
        >
      </bcc-form-item> -->
      <div class="btn-group" style="text-align: center">
        <bcc-button
          type="primary"
          size="large"
          style="margin-right: 16px"
          v-if="
            $store.state.companyInfo && $store.state.companyInfo.state === 1
          "
          :disabled="!formLock"
          @click="editForm"
          >编辑
        </bcc-button>
        <bcc-button
          type="primary"
          size="large"
          style="margin-right: 16px"
          :disabled="
            !canSubmit ||
            formLock ||
            ![1, 20, 100].includes(this.$store.state.arcUserInfo.level) ||
            lock === 1
          "
          @click="submitCompanyInfo($event)"
          >提交{{ $store.state.companyInfo ? "" : "申请" }}
        </bcc-button>
        <bcc-button
          size="large"
          v-if="!$store.state.companyInfo"
          :disabled="formLock"
          @click="saveCache"
          >保存草稿
        </bcc-button>
        <!--        <bcc-button size="large" v-else @click="cancelEdit">取消</bcc-button>-->
      </div>
    </bcc-form>
  </div>
</template>

<script>
import axios from "axios";
import { whether } from "../../apis/company";

const requiredKey = [
  "co_name",
  "uscc",
  "description",
  "company_addr",
  "contact",
  "tel",
  "email",
  "license_url",
  "application_url",
  "identity_cards_number",
  "net_addr",
  "safety_questionnaire",
];

const watchKey = {};
requiredKey.forEach((key) => {
  watchKey[`form.${key}`] = function () {
    if (!this.errors.length) return;
    if (this.errors.includes(key)) {
      this.errors.splice(this.errors.indexOf(key), 1);
    }
  };
});

let validateEmail = (rule, value, callback) => {
  if (!value) return callback(new Error("请填写联系邮箱"));
  if (!/\S+@\S+\.\S+/.test(value)) return callback(new Error("邮箱格式不正确"));
  callback();
};

let validateAddr = (rule, value, callback) => {
  if (!value) return callback(new Error("请填写公司网址"));
  if (!/^https?:\/\//.test(value)) return callback(new Error("请填写公司网址"));
  callback();
};

let validateIdentityCode = (rule, value, callback) => {
  if (!value) return callback(new Error("请填写身份证号码"));
  if (value.length !== 18) return callback(new Error("身份证格式不正确"));
  const format =
    /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  // 号码规则校验
  if (!format.test(value)) {
    return callback(new Error("身份证格式不正确"));
  }
  // 区位码校验
  // 出生年月日校验   前正则限制起始年份为1900;
  const year = value.substr(6, 4), //身份证年
    month = value.substr(10, 2), //身份证月
    date = value.substr(12, 2), //身份证日
    time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
    now_time = Date.parse(new Date()), //当前时间戳
    dates = new Date(year, month, 0).getDate(); //身份证当月天数
  if (time > now_time || date > dates) {
    return callback(new Error("身份证格式不正确"));
  }
  //校验码判断
  const c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //系数
  const b = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"]; //校验码对照表
  const id_array = value.split("");
  let sum = 0;
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k]);
  }
  if (id_array[17].toUpperCase() !== b[sum % 11].toUpperCase()) {
    return callback(new Error("身份证格式不正确"));
  }
  callback();
};

let validatePhoneNumber = (rule, value, callback) => {
  if (!value) return callback(new Error("请填写手机号"));
  if (value.length !== 11) return callback(new Error("手机号格式不正确"));
  if (!/^1/.test(value)) return callback(new Error("手机号格式不正确"));
  callback();
};

import StatusBar from "@/components/StatusBar";
import UploadBtn from "@/components/UploadBtn";

export default {
  name: "companyDetail",
  components: {
    StatusBar,
    UploadBtn,
  },
  created() {
    const { companyInfo, arcUserInfo } = this.$store.state;
    if (companyInfo) {
      let formLock = false;
      if (companyInfo.state === 2) {
        this.topStatus = {
          text: `非常抱歉！您的企业开发者资质因 <span style="color: #4fbdea;">${
            companyInfo.reject_reason || ""
          }</span> 原因未通过后台审核，请修改信息重新提交企业认证申请吧~`,
          type: "error",
        };
        formLock = false;
      }
      if (companyInfo.state === 1) {
        this.topStatus = {
          text: "已完成认证填写并审核通过，可申请接入应用",
          type: "success",
        };
        formLock = false;
      }
      if (companyInfo.state === 0) {
        this.topStatus = {
          text: "您的认证信息还在审核中",
          type: "warning",
        };
        formLock = true;
      }
      if (![1, 20, 100].includes(arcUserInfo.level)) {
        formLock = true;
      }
      this.formLock = formLock;
      this.renderCompanyInfo(companyInfo);
      if (companyInfo.coid) {
        this.getWhether(companyInfo.coid);
      }
    } else {
      this.formLock = false;
      // this.notify = this.$notify({
      //   content: '暂未认证身份信息',
      //   type: 'warning',
      //   offset: 60,
      //   onClose: () => {
      //     this.notify = null
      //   }
      // })

      try {
        const companyInfo = JSON.parse(localStorage.getItem(this.cacheKey));
        this.renderCompanyInfo(companyInfo);
      } catch (e) {
        console.error(e);
      }
    }

    axios
      .get(this.agreement_form_download, {
        responseType: "blob",
      })
      .then(({ data }) => {
        this.agreement_form_download = URL.createObjectURL(data);
      })
      .catch((e) => {
        console.error(e);
      });
    axios
      .get(this.questionnaire_download, {
        responseType: "blob",
      })
      .then(({ data }) => {
        this.questionnaire_download = URL.createObjectURL(data);
      })
      .catch((e) => {
        console.error(e);
      });
  },
  data() {
    return {
      form: {
        coid: "",
        co_name: "", // 公司名称
        net_addr: "", // 公司网址
        uscc: "", // 企业代码：统一社会信用代码 / 工商执照注册号
        company_addr: "", // 公司地址
        description: "", // 公司简介
        contact: "", // 联系人
        email: "", // 联系邮箱
        tel: "", // 联系手机
        captcha: "", // 手机验证码
        license_url: "", // 营业执照
        application_url: "", // 申请公函
        identity_cards_number: "", // 身份证
        safety_questionnaire: "", // 调查问卷 url
        sq_file_name: "", // 文件名称
      },
      rules: {
        email: [{ validator: validateEmail, trigger: "blur" }],
        identity_cards_number: [
          { validator: validateIdentityCode, trigger: "blur" },
        ],
        net_addr: [{ validator: validateAddr, trigger: "blur" }],
        tel: [{ validator: validatePhoneNumber, trigger: "blur" }],
      },
      agreeArcOpenProtocol: true,
      errors: [],
      requiredKey,
      submitLoading: false,
      cacheKey: "arcopenComanyAddInfo",
      agreement_form_download: `//${
        window.$bili_arcopen.isUAT ? "uat-" : ""
      }s1.hdslb.com/bfs/templar/york-static/9M3js6v2ySFk2Qjz.docx`,
      questionnaire_download: `//${
        window.$bili_arcopen.isUAT ? "uat-" : ""
      }i0.hdslb.com/bfs/live/3926adfa7126eda87026694a18fdc4836ef03f85.zip`,
      notify: null,
      formLock: true,
      topStatus: null,
      showVerifyCode: false,
      lock: 0,
    };
  },
  watch: {
    ...watchKey,
    showVerifyCode(val) {
      if (this.errors.includes("captcha")) {
        this.errors.splice(this.errors.indexOf("captcha"), 1);
      }

      if (!val) {
        if (this.requiredKey.includes("captcha")) {
          this.requiredKey.splice(this.requiredKey.indexOf("captcha"), 1);
        }
      } else {
        this.requiredKey.push("captcha");
      }
    },
  },
  beforeDestroy() {
    if (this.notify && this.notify.close) {
      this.notify.close();
    }
  },
  computed: {
    isManage() {
      return [1, 20].includes(this.$store.state.arcUserInfo.level);
    },
    canSubmit() {
      return (
        this.agreeArcOpenProtocol &&
        !this.submitLoading &&
        Object.keys(this.form).every((key) => {
          if (requiredKey.includes(key)) {
            return !!this.form[key];
          } else {
            return true;
          }
        })
      );
    },
    disableVerification() {
      let validate = false;
      validatePhoneNumber("", this.form.tel, (e) => {
        if (!e) validate = true;
      });
      if (!validate) return true;
      return (
        this.formLock ||
        (this.$store.state.companyInfo &&
          this.form.tel === this.$store.state.companyInfo.tel)
      );
    },
  },
  methods: {
    resetPhone() {
      if (
        this.$refs["bcc-verification"].seconds > 0 &&
        !this.$refs["bcc-verification"].canClick
      ) {
        this.$message({
          content: `${this.$refs["bcc-verification"].seconds}秒后，才可以更换手机号`,
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }
      this.showVerifyCode = false;
      this.$refs["bcc-verification"].content = "获取验证码";
    },
    async sendVerification(countDown) {
      await this.$api.verify
        .sendCaptch({
          mobile: this.form.tel,
        })
        .then(() => {
          this.showVerifyCode = true;
          this.form.captcha = "";
          countDown();
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: e.message || "获取验证码失败",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    saveCache() {
      try {
        localStorage.setItem(this.cacheKey, JSON.stringify(this.form));
        this.$message({
          content: "保存成功",
          duration: 1500,
          type: "success",
          offset: 60,
        });
      } catch (e) {
        console.error(e);
      }
    },
    async submitCompanyInfo(e) {
      this.$LogReport.sendCustomEvent(
        "openplat_developinformation_submit_click"
      );
      e.preventDefault();
      let validateRes;
      this.$refs["form"].validate((value, field) => {
        validateRes = value;
        if (!value && field && Object.keys(field).length) {
          const list = Object.keys(field);
          const k = list[0];
          if (field[k].length) {
            let t = "";
            if (field[k][0] instanceof Error) {
              t = field[k][0].message;
            } else {
              t = field[k][0];
            }

            this.$message({
              content: t,
              type: "exception",
              offset: 60,
              duration: 1500,
            });
          }
        }
      });
      if (!validateRes) return;

      try {
        localStorage.removeItem(this.cacheKey);
      } catch (e) {
        console.error(e);
      }
      if (this.form.coid) {
        // 编辑
        if (
          this.form.tel !== this.$store.state.companyInfo.tel &&
          !this.form.captcha
        ) {
          this.$message({
            content: "请验证手机验证码",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        this.submitLoading = true;
        this.$api.company
          .edit({
            ...this.form,
            captcha: this.form.captcha || undefined,
          })
          .then(() => {
            this.submitLoading = false;
            this.$emit("next");
          })
          .catch((e) => {
            this.submitLoading = false;
            console.error(e);
            this.$message({
              content: e.message,
              type: "exception",
              offset: 60,
              duration: 1500,
            });
          });
      } else {
        // 新建
        if (!this.form.captcha) {
          this.$message({
            content: "请验证手机验证码",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        this.submitLoading = true;
        this.$api.company
          .submit(this.form)
          .then(() => {
            this.$LogReport.sendCustomEvent(
              "openplat_developinformation_submit_success"
            );
            this.submitLoading = false;
            this.$emit("next");
          })
          .catch((e) => {
            this.submitLoading = false;
            console.error(e);
            this.$message({
              content: e.message,
              type: "exception",
              offset: 60,
              duration: 1500,
            });
          });
      }
    },
    renderCompanyInfo(companyInfo) {
      if (!companyInfo) return;
      Object.keys(this.form).forEach((key) => {
        this.form[key] = companyInfo[key] || "";
      });
      this.form.application_url = this.form.application_url.replace(
        /^https?/,
        "https"
      );
      this.form.license_url = this.form.license_url.replace(/^https?/, "https");
    },
    cancelEdit() {
      this.$router.go(-1);
    },
    async questionnaireUpload(file) {
      return await this.$api.company
        .questionnaireUpload(file)
        .then((data) => {
          this.form.safety_questionnaire = data.url;
          this.form.sq_file_name = file.name;
          return data.url;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: e.message,
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    async licenseUploader(file) {
      if (this.errors.includes("license_url")) {
        this.errors.splice(this.errors.indexOf("license_url"), 1);
      }
      return await this.$api.company
        .licenseUpload(file)
        .then((data) => {
          this.form.license_url = data.url;
          return data.url;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: e.message,
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    async applicationUploader(file) {
      if (this.errors.includes("application_url")) {
        this.errors.splice(this.errors.indexOf("application_url"), 1);
      }
      return await this.$api.company
        .applicationUpload(file)
        .then((data) => {
          if (!data.url) return;
          const url = data.url.replace(/^https?/, "https");
          this.form.application_url = url;
          return url;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: e.message,
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    editForm() {
      this.$LogReport.sendCustomEvent("openplat_developinformation_edit_click");
      this.formLock = false;
    },

    async getWhether(coid) {
      const params = {
        coid: coid,
      };
      const data = await whether(params);
      const { lock } = data;
      this.lock = lock;
    },
  },
};
</script>
<style lang="less" scoped>
@width: 872px;
.certification-apply {
  width: @width;
  margin: 0 auto;
  padding-bottom: 40px;
  position: relative;

  .status-bar {
    padding-top: 20px;
    margin-bottom: -20px;
  }

  h2 {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #212121;
    margin-bottom: 36px;
    padding-top: 48px;
  }

  .bcc-input {
    width: 760px;
  }

  .user-hint {
    background: #f7fbff;
    border: 1px solid #55cbf2;
    border-radius: 4px;
    width: 100%;
    height: 88px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: 32px;

    img.business-license {
      width: 98px;
      height: 54px;
      margin: 0 20px;
    }

    .hint-text {
      width: 640px;

      h3 {
        font-family: PingFangSC-Medium, sans-serif;
        font-size: 14px;
        color: #00a1d6;
        letter-spacing: 0;
        line-height: 14px;
      }

      span {
        display: inline-block;
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 12px;
        color: #505050;
        line-height: 18px;
        margin-top: 8px;
      }
    }

    .download-doc {
      background: #ffffff;
      border: 2px dashed rgba(0, 161, 214, 0.5);
      border-radius: 2px;
      width: 64px;
      height: 72px;
      box-sizing: border-box;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 28px;
        height: 28px;
      }

      a {
        font-family: PingFangSC-Regular, sans-serif;
        font-size: 12px;
        color: #00a1d6;
        letter-spacing: 0;
        margin-top: 5px;
      }
    }
  }

  .tip {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: #999999;
    display: block;
  }
  .input-disabled-txt {
    color: #212121;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .disabled {
    /deep/.bcc-input-inner {
      color: #999 !important;
      background-color: #f4f4f4 !important;
    }
  }
  .ques-txt {
    line-height: 14px;
    font-size: 14px;
    padding-left: 10px;
    color: #505050;
    max-width: 666px;
    display: inline-block;
  }
}
</style>
